import axios from '@/utils/request'
import utils from '@/utils/index.js'
var Qs = require('qs')

export default {
	// 2020-11-21
	allocateSearch(params) {
		return axios.get('/pick-shelfs/allocate?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
	},
	// 2020-11-28
	pendingPickAllocateCount() {
		return axios.get('/pick-shelfs/pending-pick-allocate-count');
	},
	// 2020-11-18
	pick(id, params) {
		return axios.put('/pick-shelfs/' + id + '/pick', params);
	},
	// 2020-12-20
	batchPick(params) {
		return axios.put('/pick-shelfs/batch-pick', params);
	},
	// 2020-12-05
	buildPickingList(params) {
		return axios.put('/pick-shelfs/build-picking-list', params);
	},
	// 2021-02-23
	remakeSearch(params) {
		return axios.get('/pick-shelfs/remake?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
	},
	// 2021-02-23
	pendingPickRemakeCount() {
		return axios.get('/pick-shelfs/pending-pick-remake-count');
	},
}
